import React from 'react'
import { useIntl } from 'gatsby-plugin-intl'
import Layout from '../components/Layout/index'
import Header from '../modules/Header'
import Footer from '../modules/Footer'
import PrivacyPage from '../components/StaticPages/PrivacyPage'
import SEO from '../components/seo'
import messages from '../messages/pageTitles.lang'
import metaDescription from '../messages/pageMetaDescriptions.lang'

const IndexPage = () => {
  const { formatMessage, locale } = useIntl()

  return (
    <Layout footer={<Footer />}>
      <SEO
        title={formatMessage(messages.TitlePrivacyPolicy)}
        description={formatMessage(metaDescription.privacyPolicyDescription)}
        lang={locale}
      />
      <Header withTeaser />
      <PrivacyPage />
    </Layout>
  )
}

export default IndexPage
